import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ShoppingCartDrawerComponent } from './pages/store/cart/shopping-cart-drawer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ShoppingCartDrawerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('argentus-mundo-3d-front');
}
